// Count slides
const swiperShopByItem = document.querySelectorAll(".shop_by_collection_column .swiper-slide");
const numberItems = swiperShopByItem.length;

// Set rows based on total number of items
const rowsItem = numberItems > 4 ? 2 : 1;

// Initialize Swiper with numbered pagination
new Swiper(".shop_by_collection_column .shop-by-carousel", {
  slidesPerView: 2,
  grid: {
    rows: rowsItem,
    fill: 'row',
  },
  spaceBetween: 12,
  navigation: {
    nextEl: ".shop_by_collection_column .swiper-button-next",
    prevEl: ".shop_by_collection_column .swiper-button-prev",
  },
  pagination: {
    el: ".shop_by_collection_column .swiper-pagination",
    clickable: true,
    type: 'fraction',
    renderFraction: function (currentClass, totalClass) {
      return '<span class="' + currentClass + '"></span>' +
             ' / ' +
             '<span class="' + totalClass + '"></span>';
    }
  },
  breakpoints: {    
    0: {
      slidesPerView: 2,
      slidesPerGroup: 2,
    },    
    1024: {
      slidesPerView: 3,
      slidesPerGroup: 3,
    },
    1100: {
      slidesPerView: 4,
      slidesPerGroup: 4,
    },
  },
});